import { render, staticRenderFns } from "./afterProblemDialog.vue?vue&type=template&id=307861d3&scoped=true"
import script from "./afterProblemDialog.vue?vue&type=script&lang=js"
export * from "./afterProblemDialog.vue?vue&type=script&lang=js"
import style0 from "./afterProblemDialog.vue?vue&type=style&index=0&id=307861d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307861d3",
  null
  
)

export default component.exports